import React, {useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { CheckCircle, AlertCircle, Upload, Users, Calendar, Mail, Phone, MapPin, GraduationCap, Loader2 } from 'lucide-react';
import MainHeader from './MainHeader';
import Footer from './Footer';
import userQueries from '../../queries/userQueries';
import paymentService from '../../services/paymentService';
import { useNavigate } from 'react-router-dom';
import ContactSupportButton from './FeedbackButton';
import whatssap from '../../images/whatssapp/WhatsApp.webp'
import { toast, Toaster } from 'sonner';
import RouteConstants from '../../constant/Routeconstant';

// Loading Overlay Component
const LoadingOverlay = ({ message = "Processing..." }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-8 max-w-sm mx-4 text-center">
      <div className="flex justify-center mb-4">
        <Loader2 className="w-12 h-12 text-emerald-600 animate-spin" />
      </div>
      <h3 className="text-lg font-semibold text-gray-800 mb-2">Please Wait</h3>
      <p className="text-gray-600">{message}</p>
      <div className="mt-4">
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div className="bg-emerald-600 h-2 rounded-full animate-pulse" style={{ width: '60%' }}></div>
        </div>
      </div>
    </div>
  </div>
);

// Inline Loader Component for Button
const ButtonLoader = () => (
  <div className="flex items-center justify-center gap-2">
    <Loader2 className="w-5 h-5 animate-spin" />
    <span>Processing Registration...</span>
  </div>
);


const RegistrationForm = () => {
  const { 
    register, 
    handleSubmit, 
    watch, 
    reset, 
    formState: { errors, isSubmitting } 
  } = useForm();
  
  const [submitted, setSubmitted] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [loadingMessage, setLoadingMessage] = React.useState("Processing...");
  const navigate = useNavigate();


    useEffect(() => {
          navigate(RouteConstants.ROOT)
    }, []);
   
  const createUser = userQueries.useCreateuserMutation((payload) => {
    console.log("User created successfully", payload);
    // you could do any local success handling here
});
  const delegateCategory = watch('delegateCategory');

  const paymentPage = async (userId, data) => {
    try {
      const paymentData = {
        amount: delegateCategory === 'student' ? 250 : 500,
        customerEmail: data.email,
        customerPhone: data.phone,
        customerName: data.full_name,
        description: 'ILFK 2025-26 Registration Fee',
        userId: userId.toString(),
        metadata: {
          source: 'web',
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString()
        }
      };

      const result = await paymentService.initiatePayment(paymentData);
      if (result?.paymentUrl) {
        window.location.href = result.paymentUrl;
      } else {
        setError('Payment initiation failed. Please try again.');
      }
    } catch (err) {
      console.error('Payment initiation failed:', err);
      setError('Payment initiation failed. Please try again.');
    }
  };

//  const onSubmit = async (data) => {
//   try {
//     setLoading(true);
//     setError(null);

//     const payload = {
//       ...data,
//       platform: "web"
//     };

//     const response = await createUser.mutateAsync(payload);

//     if (response?.success) {
//       const userId = response?.data?.userId;
//       await paymentPage(userId, data);
//       navigate('/atsuccess');
//     } else if (response?.message?.includes("User Exists")) {
//       setError("User already exists with this phone or email.");
//     } else {
//       setError(response?.message || "Something went wrong");
//     }
//   } catch (err) {
//     console.error('Registration failed:', err);
//     setError("Something went wrong. Please try again.");
//   } finally {
//     setLoading(false);
//   }
// };

 const onSubmit = async (data) => {
  try {
    setLoading(true);
    setError(null);

    // Create FormData for file upload
    const formData = new FormData();
    
    // Append all form fields to FormData, excluding the file field
    Object.keys(data).forEach(key => {
      if (key === 'student_id_proof') {
        // Handle file upload for students - append the actual file, not the field
        if (delegateCategory === 'student' && data[key] && data[key][0]) {
          formData.append('student_document', data[key][0]);
        }
        // DON'T append student_id_proof as a regular field
      } else {
        // Handle other fields, ensure they're not null/undefined
        const value = data[key];
        if (value !== null && value !== undefined && value !== '') {
          formData.append(key, value);
        }
      }
    });
    
    // Add platform field
    formData.append('platform', 'web');

    // Ensure gender is not null if not selected
    if (!data.gender) {
      formData.delete('gender'); // Remove gender if not selected
    }

    // Debug: Log FormData contents
    // console.log('FormData contents:');
    // for (let [key, value] of formData.entries()) {
    //   console.log(key, value);
    // }

    // Use createUser mutation with FormData
    const response = await createUser.mutateAsync(formData);
    console.log(">>>",response.message)
    const userId = response?.data?.userId;
    if (response?.success) {
      await paymentPage(userId, data);
      // navigate('/atsuccess');
    } else if (response?.message?.includes("User exists but payment is incomplete. Proceeding to payment.")) {
      // setError("User already exists with this phone or email.");
      const resdata = response?.data
      await paymentPage(userId, resdata);
    }else if (response?.message?.includes("registration is complete")) {
      // setError("already exists and registration is complete");
      toast.error("User already exists", {
    description: "This email or phone is already registered.",
});
    } else {
      setError(response?.message || "Something went wrong");
    }
  } catch (err) {
    console.error('Registration failed:', err);
    setError("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <MainHeader />
      <Toaster position="top-center" richColors />

        {/* Loading Overlay */}
        {loading && <LoadingOverlay message={loadingMessage} />}


      <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-100 py-8 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <div className="text-center mb-6">
              <h1 className="text-3xl font-bold text-gray-800 mb-2">
                International Literature Festival of Kerala
              </h1>
              <p className="text-lg text-emerald-600 font-medium">Delegate Registration</p>
            </div>
            <div className="flex justify-end mb-4">
              <ContactSupportButton
                buttonText="Get Help"
                buttonTextColor="text-blue-600"
                buttonHoverColor="hover:text-blue-800"
                buttonIconColor="blue"
              />
            </div>
            {/* whatssapp heading */}
              <div className="rounded-lg overflow-hidden mb-6">
               <div className="flex items-center bg-[#5ac95d] p-4 pl-6 rounded-t-lg">
                <img
                  src={whatssap} // Replace with actual import or URL
                  alt="WhatsApp"
                  className="w-9 h-9 mr-3"
                />
                <h4 className="text-sm md:text-base font-medium text-black">
                  For any assistance or queries related to registration, please contact us on WhatsApp at
                  <a
                    href="https://wa.me/919074661558"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-2 underline text-white"
                  >
                    9074661558
                  </a>
                </h4>
              </div>

            <div className="bg-emerald-50 rounded-lg p-6 mb-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">
                Thank you for choosing to be a delegate at ILFK!
              </h2>
              <p className="text-gray-700 mb-4">
                Your support and enthusiasm are what make this festival truly special.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">Why register as a delegate?</h3>
                  <ul className="text-sm text-gray-700 space-y-1">
                    <li>• A specially curated festival kit</li>
                    <li>• Lunch and refreshments during festival days</li>
                    <li>• Priority seating and access at key venues</li>
                  </ul>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">Registration Fees</h3>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span>General Public:</span>
                      <span className="font-semibold text-emerald-600">₹500</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Students (with valid ID):</span>
                      <span className="font-semibold text-emerald-600">₹250</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>

          {/* Registration Form */}
          <form onSubmit={handleSubmit(onSubmit)} className="bg-white rounded-xl shadow-lg p-8">
            <div className="space-y-6">
              <div className="flex items-center gap-2 mb-6">
                <Users className="w-5 h-5 text-emerald-600" />
                <h2 className="text-xl font-semibold text-gray-800">Personal Details</h2>
              </div>


              {/* Full Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  {...register('full_name', { 
                    required: 'Full name is required',
                    minLength: { value: 2, message: 'Full name must be at least 2 characters' }
                  })}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                    errors.full_name ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Enter your full name"
                />
                {errors.full_name && (
                  <div className="flex items-center gap-1 mt-1">
                    <AlertCircle className="w-4 h-4 text-red-500" />
                    <span className="text-sm text-red-500">{errors.full_name.message}</span>
                  </div>
                )}
              </div>

              {/* Date of Birth and Gender */}
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <Calendar className="w-4 h-4 inline mr-1" />
                    Date of Birth 
                  </label>
                  <input
                    type="date"
                    {...register('dob', 
                    //   { 
                    //   required: 'Date of birth is required',
                    //   validate: (value) => {
                    //     const dob = new Date(value);
                    //     const today = new Date();
                    //     const age = today.getFullYear() - dob.getFullYear();
                    //     return (age >= 5 && age <= 120) || 'Please enter a valid date of birth';
                    //   }
                    // }
                  )}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                      errors.dob ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {errors.dob && (
                    <div className="flex items-center gap-1 mt-1">
                      <AlertCircle className="w-4 h-4 text-red-500" />
                      <span className="text-sm text-red-500">{errors.dob.message}</span>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Gender
                  </label>
                  <div className="flex gap-4">
                    {['male', 'female', 'other'].map((gender) => (
                      <label key={gender} className="flex items-center">
                        <input
                          type="radio"
                          value={gender}
                          {...register('gender')}
                          className="mr-2 text-emerald-600 focus:ring-emerald-500"
                        />
                        <span className="text-sm capitalize">{gender}</span>
                      </label>
                    ))}
                  </div>
                  {errors.gender && (
                    <div className="flex items-center gap-1 mt-1">
                      <AlertCircle className="w-4 h-4 text-red-500" />
                      <span className="text-sm text-red-500">{errors.gender.message}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Nationality and Occupation */}
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Nationality
                  </label>
                  <input
                    {...register('country')}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                      errors.country ? 'border-red-500' : 'border-gray-300'
                    }`}
                    placeholder="Enter your country"
                  />
                  {errors.country && (
                    <div className="flex items-center gap-1 mt-1">
                      <AlertCircle className="w-4 h-4 text-red-500" />
                      <span className="text-sm text-red-500">{errors.country.message}</span>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Occupation
                  </label>
                  <input
                    {...register('occupation')}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                      errors.occupation ? 'border-red-500' : 'border-gray-300'
                    }`}
                    placeholder="Enter your occupation"
                  />
                  {errors.occupation && (
                    <div className="flex items-center gap-1 mt-1">
                      <AlertCircle className="w-4 h-4 text-red-500" />
                      <span className="text-sm text-red-500">{errors.occupation.message}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Educational Institution */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <GraduationCap className="w-4 h-4 inline mr-1" />
                  Educational Institution {delegateCategory === 'student' && '*'}
                  <span className="text-gray-500 text-xs ml-1">(if applicable)</span>
                </label>
                <input
                  {...register('educational_institution', { 
                    required: delegateCategory === 'student' ? 'Educational institution is required for students' : false 
                  })}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                    errors.educational_institution ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Enter your educational institution"
                />
                {errors.educational_institution && (
                  <div className="flex items-center gap-1 mt-1">
                    <AlertCircle className="w-4 h-4 text-red-500" />
                    <span className="text-sm text-red-500">{errors.educational_institution.message}</span>
                  </div>
                )}
              </div>

              {/* Postal Address */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <MapPin className="w-4 h-4 inline mr-1" />
                  Postal Address
                </label>
                <textarea
                  {...register('address', 
                  //   { 
                  //   required: 'Postal address is required',
                  //   minLength: { value: 10, message: 'Please provide a complete address' }
                  // }
                )}
                  rows={3}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                    errors.address ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Enter your complete postal address"
                />
                {errors.address && (
                  <div className="flex items-center gap-1 mt-1">
                    <AlertCircle className="w-4 h-4 text-red-500" />
                    <span className="text-sm text-red-500">{errors.address.message}</span>
                  </div>
                )}
              </div>

              {/* Mobile Number and Email */}
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <Phone className="w-4 h-4 inline mr-1" />
                    Mobile Number *
                  </label>
                  <input
                    type="tel"
                    {...register('phone', { 
                      required: 'Mobile number is required',
                      pattern: {
                        value: /^[6-9]\d{9}$/,
                        message: 'Please enter a valid 10-digit mobile number'
                      }
                    })}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                      errors.phone ? 'border-red-500' : 'border-gray-300'
                    }`}
                    placeholder="Enter 10-digit mobile number"
                  />
                  {errors.phone && (
                    <div className="flex items-center gap-1 mt-1">
                      <AlertCircle className="w-4 h-4 text-red-500" />
                      <span className="text-sm text-red-500">{errors.phone.message}</span>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <Mail className="w-4 h-4 inline mr-1" />
                    Email Address *
                  </label>
                  <input
                    type="email"
                    {...register('email', 
                      { 
                      required: 'Email address is required',
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: 'Please enter a valid email address'
                      }
                    }
                  )}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors ${
                      errors.email ? 'border-red-500' : 'border-gray-300'
                    }`}
                    placeholder="Enter your email address"
                  />
                  {errors.email && (
                    <div className="flex items-center gap-1 mt-1">
                      <AlertCircle className="w-4 h-4 text-red-500" />
                      <span className="text-sm text-red-500">{errors.email.message}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Delegate Category */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-4">
                  Delegate Category *
                </label>
                <div className="grid md:grid-cols-2 gap-4">
                  <div 
                    className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
                      delegateCategory === 'general' 
                        ? 'border-emerald-500 bg-emerald-50' 
                        : 'border-gray-200 hover:border-emerald-300'
                    }`}
                    onClick={() => reset({ ...watch(), delegateCategory: 'general' })}
                  >
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="general"
                        {...register('delegateCategory', { required: 'Please select a delegate category' })}
                        className="mr-3 text-emerald-600 focus:ring-emerald-500"
                      />
                      <div>
                        <div className="font-medium text-gray-800">General Public</div>
                        <div className="text-2xl font-bold text-emerald-600">₹500</div>
                      </div>
                    </label>
                  </div>

                  <div 
                    className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
                      delegateCategory === 'student' 
                        ? 'border-emerald-500 bg-emerald-50' 
                        : 'border-gray-200 hover:border-emerald-300'
                    }`}
                    onClick={() => reset({ ...watch(), delegateCategory: 'student' })}
                  >
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="student"
                        {...register('delegateCategory', { required: 'Please select a delegate category' })}
                        className="mr-3 text-emerald-600 focus:ring-emerald-500"
                      />
                      <div>
                        <div className="font-medium text-gray-800">Student</div>
                        <div className="text-2xl font-bold text-emerald-600">₹250</div>
                        <div className="text-xs text-gray-500">Valid student ID required</div>
                      </div>
                    </label>
                  </div>
                </div>
                {errors.delegateCategory && (
                  <div className="flex items-center gap-1 mt-2">
                    <AlertCircle className="w-4 h-4 text-red-500" />
                    <span className="text-sm text-red-500">{errors.delegateCategory.message}</span>
                  </div>
                )}
              </div>

              {/* Student ID Upload */}
              {delegateCategory === 'student' && (
                <div className="bg-blue-50 rounded-lg p-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <Upload className="w-4 h-4 inline mr-1" />
                    Upload Student ID *
                  </label>
                  <input
                    type="file"
                    accept="image/*,.pdf,.doc,.docx" 
                    {...register('student_id_proof', { 
                      required: 'Student ID is required for student registration'
                    })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Accepted formats: JPG, PNG, PDF, DOC, DOCX (Max 5MB)
                  </p>
                  {errors.student_id_proof && (
                    <div className="flex items-center gap-1 mt-1">
                      <AlertCircle className="w-4 h-4 text-red-500" />
                      <span className="text-sm text-red-500">{errors.student_id_proof.message}</span>
                    </div>
                  )}
                </div>
              )}

              {/* Submit Button */}
              <div className="pt-6">
                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full py-4 px-6 rounded-lg font-medium text-white transition-all ${
                    loading
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-emerald-600 hover:bg-emerald-700 focus:ring-4 focus:ring-emerald-500 focus:ring-opacity-50'
                  }`}
                >
                  {loading ? (
                    <div className="flex items-center justify-center gap-2">
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Processing Registration...
                    </div>
                  ) : (
                    `Register as  -${delegateCategory === 'student' ? 'Student ₹250' : 'Delegate ₹500'}`
                  )}
                </button>
              </div>

              <div className="text-center text-sm text-gray-500">
                <p>
                  By registering, you agree to receive updates about ILFK 2025 and confirm that all information provided is accurate.
                </p>
              </div>
            </div>
            <div className="flex justify-end mt-5">
                  <ContactSupportButton
                    buttonText="Get Help"
                    buttonTextColor="text-blue-600"
                    buttonHoverColor="hover:text-blue-800"
                    buttonIconColor="blue"
                  />
                </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RegistrationForm;